export default __webpack_public_path__ + "static/media/template.75dcefd1.svg";